import BaseList from './BaseList';
import POIData from "./POIData";
import type { POIListItem } from "./POIData";

/**
 * Wrapper to manage lists of hotels.
 */
class POIList extends BaseList<POIData> {

    /**
     * Build from list items from rest response.
     */
    static fromListItems(listItems: POIListItem[]): POIList {
        const dataItems: POIData[] = [];

        listItems.forEach((item) => {
              dataItems.push(POIData.fromListItem(item));
        });

        return new POIList(dataItems);
    }

}

export default POIList;
